import React from 'react'
import { Listbox } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { CheckIcon } from '@heroicons/react/20/solid'

const sortOptions = [
	{ value: 'pickupDate', name: 'Start date' },
	{ value: 'ppm', name: 'Price per mile' },
	{ value: 'payout', name: 'Payout' },
	{ value: 'newest', name: 'Last seen' },
]

const SortyByLoads = ({ isDarkMode, value, onChange, name }) => {
	const selectedOption = sortOptions.find(option => option.value === value) || sortOptions[3]

	const handleChange = (option) => {
		onChange({ target: { name, value: option.value } })
	}

	return (
		<Listbox value={selectedOption} onChange={handleChange}>
			<div className="relative">
				<Listbox.Button className={`w-full cursor-default rounded-md py-1 pr-8 pl-3 text-left text-xs font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-50 ${
					isDarkMode
						? 'bg-[#22272e] text-gray-200 border border-[#444c56] focus-visible:ring-[#444c56] hover:bg-[#2d333b]'
						: 'bg-white text-gray-700 border border-gray-300 focus-visible:ring-gray-400 hover:bg-gray-50'
				}`} style={{ width: '130px' }}>
					<span className="block truncate">{selectedOption.name}</span>
					<span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
						<ChevronUpDownIcon
							className="h-4 w-4 text-gray-400"
							aria-hidden="true"
						/>
					</span>
				</Listbox.Button>
				<Listbox.Options className={`absolute z-10 mt-0.5 max-h-60 w-full overflow-auto rounded-md py-1 text-xs shadow-lg ${
					isDarkMode ? 'bg-[#22272e] border border-[#444c56]' : 'bg-white border border-gray-300'
				}`}>
					{sortOptions.map((option) => (
						<Listbox.Option
							key={option.value}
							value={option}
							className={({ active, selected }) =>
								`relative cursor-default select-none py-2 pl-8 pr-4 ${
									active
										? isDarkMode
											? 'bg-[#444c56] text-white'
											: 'bg-gray-100 text-gray-900'
										: isDarkMode
										? 'text-gray-200'
										: 'text-gray-900'
								}`
							}
						>
							{({ selected }) => (
								<>
									<span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
										{option.name}
									</span>
									{selected ? (
										<span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-400">
											<CheckIcon className="h-4 w-4" aria-hidden="true" />
										</span>
									) : null}
								</>
							)}
						</Listbox.Option>
					))}
				</Listbox.Options>
			</div>
		</Listbox>
	)
}

export default SortyByLoads
